import { HTTP } from '../../../http-common';
import { createHelpers } from 'vuex-map-fields';
import { Customer } from '../../../models/customer';

import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '../../../models/httpError';

export const { mapFields: mapCustomerFields } = createHelpers({
  getterType: `customer/getField`,
  mutationType: `customer/updateField`,
});

const state = {
  customer: new Customer(),
  dealerCustomers: [],
  message: new httpError(),
};

//getters

const getters = {
  hasCustomer: (state) => state.customer.customerID > 0,
  getField,
  getCurrentCustomer: (state) => state.customer,
  customerData: (state) => state.dealerCustomers,
  newCustomer: (state) => state.customer,
};

//Mutations
const mutations = {
  setCustomer(state, customer) {
    state.customer = customer;
  },
  setUB(state, UBAccountNo) {
    state.customer.ubAccountNo = UBAccountNo;
  },
  setQantasNo(state, membershipNo) {
    state.customer.qantasMembershipNo = membershipNo;
  },
  setDealerCustomers(state, customers) {
    if (!customers || customers.length === 0) state.dealerCustomers = [];
    else {
      state.dealerCustomers = [];
      state.dealerCustomers.length = 0;
      customers.forEach(function (cust) {
        state.dealerCustomers.push(cust);
      });
    }
  },
  setProgress(state, message) {
    state.message = message;
  },
  setAddress(state, addrID) {
    state.customer.addressID = addrID;
  },
  setGroupNo(state, groupNo) {
    state.customer.groupNo = groupNo;
  },
  updateDirector(state) {
    if (state.customer.companyDetails) {
      state.customer.companyDetails.directorGivenName =
        state.customer.firstName;
      state.customer.companyDetails.directorSurname = state.customer.surname;
    }
  },
  updateDirectorName(state, director) {
    state.customer.customer.firstName = director.directorGivenName;
    state.customer.customer.surname = director.directorSurname;
  },
  updateField,
  setCustomerDirectDebit(state, directDebit) {
    state.customer.directDebit = directDebit;
  },
  setCustomerCompany(state, company) {
    state.customer.companyDetails = company;
  },
};

//ACTIONS
const actions = {
  getDealerCustomer(account) {
    return state.dealerCustomers.find((s) => s.ubAccountNo == account);
  },
  addCustomerToUB({ commit, state, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      if (state.customer.ubAccountNo > 0) {
        resolve();
        return;
      }

      var response = HTTP.post('Customer/AddCustomerToUB', state.customer);
      response
        .then((data) => {
          var result = data.data;
          commit('setUB', result.ubAccountNo);
          dispatch(
            'setMessage',
            new httpError({
              message: 'updated Customer',
              httpStatus: 200,
            })
          );

          rootState.orders.rows[0].ubAccountNo = result.ubAccountNo;
          dispatch(`updateCustomer`, result.customerID);
          resolve(result);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'unable to create UB ' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },

  resetCustomer({ commit }) {
    commit('setCustomer', new Customer());
  },
  async getCustomer({ commit, dispatch }, customerID) {
    try {
      let response = await HTTP.get('Customer/GetCustomer/' + customerID);
      commit('setCustomer', response.data);
      dispatch(
        'setMessage',
        new httpError({
          message: 'Retrieved OK',
          httpStatus: 200,
        })
      );
      return Promise.resolve(response.data);
    } catch (e) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error:' + e,
          httpStatus: 500,
        })
      );
      return Promise.reject(e);
    }
  },
  listCustomers({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('retrieveDealerCustomers', {
        type: !payload.customerType ? 'both' : payload.customerType,
        isQBR: false,
        includeNonContract: false,
        dealerID: payload.dealerID,
        pagination: payload.pagination,
        keyword: payload.keyword,
      })
        .then((data) => {
          // commit('setDealerCustomers', data.data);
          resolve(data.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  addCustomer({ state, commit, rootState, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit('setGroupNo', rootState.orders.dealer.dealer.groupNo);

      var response = HTTP.post('Customer', state.customer);
      response
        .then(function (data) {
          var resultData = data.data;
          commit('setCustomer', resultData);
          dispatch('orders/getContacts', rootState.orders.rows[0].orderID, {
            root: true,
          });
          dispatch(
            'setMessage',
            new httpError({
              message: 'Submitted OK',
              httpStatus: 200,
            })
          );

          if (!payload.createOnly) {
            dispatch(
              'orders/addOrder',
              {
                customerID: state.customer.customerID,
                type: payload.orderType,
              },
              {
                root: true,
              }
            );
            //create order.
          }

          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error in Saving',
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateCustomer(
    { state, commit, dispatch, rootState, rootGetters },
    customerID
  ) {
    return new Promise(async (resolve, reject) => {
      if (!rootGetters['orders/isResidential'])
        var company = HTTP.put(
          `order/UpdateCompany/${rootState.orders.rows[0].orderID}`,
          state.customer.companyDetails.abnLookupResponse
            ? state.customer.companyDetails
            : rootState.orders.company.company
        );

      var response = HTTP.put(
        `Customer/UpdateCustomer/${customerID}/${rootState.orders.rows[0].orderID}`,
        state.customer
      );
      Promise.all([company, response]).then((x) => {
        let resultData = x[1].data;
        dispatch('orders/getContacts', rootState.orders.rows[0].orderID, {
          root: true,
        });
        commit('setCustomer', resultData);
        dispatch(
          'setMessage',
          new httpError({
            message: 'Updated OK',
            httpStatus: 200,
          })
        );
        if (rootState.orders.rows[0].orderID === 0) {
          dispatch('orders/addOrder', state.customer.customerID, {
            root: true,
          });
          dispatch(
            'setMessage',
            new httpError({
              message: 'Updated OK',
              httpStatus: 200,
            })
          );
          resolve(resultData);
        }
      });
    });
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
  async getCustomers({ dispatch, rootState }) {
    try {
      let result = await HTTP.get(
        `Customer/GetCustomers/${rootState.orders.dealer.dealer.dealerID}`
      );
      return Promise.resolve(result);
    } catch (e) {
      return Promise.reject(e.response);
    }
  },

  async retrieveDealerCustomers({ rootState }, payload) {
    try {
      let result = rootState.orders.isDirectSales
        ? await HTTP.post(`Customer/RetrieveDirectSalesCustomers`, payload)
        : await HTTP.post(`Customer/RetrieveDealerCustomers`, payload);
      return Promise.resolve(result);
    } catch (e) {
      return Promise.reject(e.response);
    }
  },
  async getCustomerUBDetails({ commit, dispatch }, ubAccountNo) {
    try {
      let response = await HTTP.get('Customer/GetCompanyABN/' + ubAccountNo);
      return Promise.resolve(response.data.customer);
    } catch (e) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error:' + e,
          httpStatus: 500,
        })
      );
      return Promise.reject(e);
    }
  },
  setCompany({ commit }, payload) {
    commit('setCustomerCompany', payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
